import { useAuth } from '../pages/login/OAuth';

const useUserService = () => {
    const { api } = useAuth();

    const getMe = () =>
        api().get('/users/get/me');

    const updateMe = (data) =>
        api().patch('/users/update/me', data);

    const requestPasswordReset = (email) =>
        api().post('/users/reset/pass', { email });

    const resetPassword = (token, data) =>
        api().post(`/users/reset/pass/${token}`, data);

    const getUsers = () =>
        api().get('/users/');

    return {
        getMe,
        updateMe,
        requestPasswordReset,
        resetPassword,
        getUsers,
    };
};

export default useUserService;
